/*
login-footer-ctrl.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('login/modules/login-footer/controllers/login-footer-ctrl',['angular', '../services/login-footer-i18n'], function () {

    // Module Dependencies
    var dependencies = [
        'LoginFooter.Services.i18n'
    ];

    // Module Definition
    var mod = angular.module('LoginFooter.Controllers.LoginFooterCtrl', dependencies);

    /**
     * @name LoginFooterCtrl
     * @type controller
     *
     * @description
     * Controller for the 'Login' page's footer.
     */
    mod.controller('LoginFooterCtrl', ['$scope', 'LoginFooter.i18n',
        function ($scope, i18n) {
            // Collection of localized messages
            $scope.msg = i18n.getMessages();
        }]);

});

